import UserRole from "./userRole";

export default class User {

  id!: number;
  uuid!: string;
  firstName!: string;
  lastName!: string;
  fullName!: string;
  title!: string | null;
  email!: string;
  hasEmailAlert!: number;
  mav1Id!: number | null;
  notaryId!: number | null;
  image!: string | null;
  importedTs!: number | null;
  ip!: string;
  isActive!: boolean;
  isDeleted!: boolean;
  isEmailVerified!: boolean;
  isFirstAuth!: boolean;
  phone!: string;
  timezone!: string;
  usRegion!: number | null;
  workingInterval!: string | null;
  userRoleId!: number;
  userRoleName!: string;
  activityStatus!: number;
  authLockedUntilTs!: number | null;
  bounceSubtype!: number | null;
  complaintSubtype!: number | null;
  dealerGroupId!: number | null;
  dealerGroupName!: string | null;
  dealerRegionId!: number | null;
  dealerRegionName!: string | null;
  dealerStoreId!: number | null;
  dealerStoreName!: string | null;
  tutorials!: {type: number, shouldShow: boolean}[];
  numOfFailedAuthAttempts!: number | null;
  numOfFailedVerifAttempts!: number | null;
  isImpersonated!: boolean;
  verifCodeConfirmedTs!: number;
  verifCodeCreatedTs!: number;
  passwdUpdatedTs!: number;
  lastActiveTs!: number;
  lastAuthTs!: number;
  createdTs!: number;
  updatedTs!: number;

  static ACTIVITY_STATUS_OFFLINE = 0;
  static ACTIVITY_STATUS_IDLE = 1;
  static ACTIVITY_STATUS_ACTIVE = 2;

  static PASSWD_RESET_REASON_LOST = 1;
  static PASSWD_RESET_REASON_OLD = 2;

  static NOTIF_CHANNEL_EMAIL = 1;
  static NOTIF_CHANNEL_SMS = 2;
  static NOTIF_CHANNEL_WEB = 3;

  static US_REGION_ALL = 1;
  static US_REGION_WEST = 2;
  static US_REGION_CENTRAL = 3;
  static US_REGION_EAST = 4;

  static getUsRegionMap() {
    return {
      [this.US_REGION_ALL]: 'All',
      [this.US_REGION_WEST]: 'West',
      [this.US_REGION_CENTRAL]: 'Central',
      [this.US_REGION_EAST]: 'East',
    };
  }

  static getUsRegionName(id: number) {
    return this.getUsRegionMap()[id];
  }

  getFullName() {
    return `${this.firstName} ${this.lastName}`;
  }

  static getActivityStatusMap() {
    return {
      [this.ACTIVITY_STATUS_OFFLINE]: 'Offline',
      [this.ACTIVITY_STATUS_IDLE]: 'Idle',
      [this.ACTIVITY_STATUS_ACTIVE]: 'Active',
    };
  }

  static getActivityStatusName(id: number) {
    return this.getActivityStatusMap()[id];
  }

  /***** ROLES *****/

  isMasterAdmin() {
    return UserRole.isMasterAdmin(this.userRoleId);
  }

  isAdmin() {
    return UserRole.isAdmin(this.userRoleId);
  }

  isScheduler() {
    return UserRole.isScheduler(this.userRoleId);
  }

  isDsc() {
    return UserRole.isDsc(this.userRoleId);
  }

  isAccountManager() {
    return UserRole.isAccountManager(this.userRoleId);
  }

  isLeadOps() {
    return UserRole.isLeadOps(this.userRoleId);
  }

  isDealerGroupManager() {
    return UserRole.isDealerGroupManager(this.userRoleId);
  }

  isDealerRegionalManager() {
    return UserRole.isDealerRegionalManager(this.userRoleId);
  }

  isDealerStoreManager() {
    return UserRole.isDealerStoreManager(this.userRoleId);
  }

  isDealerFinanceManager() {
    return UserRole.isDealerFinanceManager(this.userRoleId);
  }

  isDealerSalesManager() {
    return UserRole.isDealerSalesManager(this.userRoleId);
  }

  isDealerUpperManager() {
    return UserRole.isDealerUpperManager(this.userRoleId);
  }

  isDealerLowerManager() {
    return UserRole.isDealerLowerManager(this.userRoleId);
  }

  isDealerManager() {
    return UserRole.isDealerManager(this.userRoleId);
  }

  isDealerStoreUser() {
    return UserRole.isDealerStoreUser(this.userRoleId);
  }

  isDealerStoreLimitedUser() {
    return UserRole.isDealerStoreLimitedUser(this.userRoleId);
  }

  isNotary() {
    return UserRole.isNotary(this.userRoleId);
  }

  /***** ROLE TYPES *****/

  isAdminType() {
    return UserRole.isAdminType(this.userRoleId);
  }

  isDealerType() {
    return UserRole.isDealerType(this.userRoleId);
  }

  isNotaryType() {
    return UserRole.isNotaryType(this.userRoleId);
  }
}